import i18n from 'i18next';
import { initReactI18next } from 'react-i18next';
import LanguageDetector from 'i18next-browser-languagedetector';

// Import translation files
import translationEN from './translation/en_translation.json';
import translationIT from './translation/it_translation.json';

// the translations
const resources = {
  en: {
    translation: translationEN
  },
  it: {
    translation: translationIT
  }
};

i18n
  .use(initReactI18next)
  .use(LanguageDetector)
  // init i18next
  .init({
    resources,
    lng: "it",
    fallbackLng: 'it',
    debug: process.env.REACT_APP_TYPE === 'DEV',
    interpolation: {
      escapeValue: false, // not needed for react as it escapes by default
    },
    react: {
      useSuspense: false,
    },
    load: 'languageOnly', // Only load language, not locale (e.g., 'it' instead of 'it-IT')
    ns: ['translation'], // Explicitly define namespaces
    defaultNS: 'translation',
    detection: {
      order: ['localStorage', 'navigator'], // Check localStorage first, then browser settings
      caches: ['localStorage'], // Cache language detection in localStorage
      lookupLocalStorage: 'preferredLanguage',
    },
    initImmediate: false // This forces synchronous loading of resources
  });

export default i18n;
